import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import Loading from "../Shared/Loading";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";

// Spripe public key
const stripePromise = loadStripe(
  "pk_test_51L2EsdAKL9h2k26kiUAfGJcl9QIF2AtlIDQvpKcR6xxeDSrWtZ7oSaVb2VMaaxN2pJdBnCeLwAlCNBmSqYX84kmO005wAJzn56"
);

const Payment = () => {
  // Get order for payment
  const { id } = useParams();
  const url = `https://electric-cart-server.onrender.com/order/${id}`;
  const { data: order, isLoading } = useQuery(["order", id], () =>
    fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((res) => res.json())
  );

  if (isLoading) {
    return <Loading></Loading>;
  }

  return (
    <div>
      <div className="card w-50 max-w-md bg-base-100 shadow-xl my-12">
        <div className="card-body">
          <p className="text-success font-bold">Hello, {order.name}</p>
          <h2 className="card-title">Please Pay for: {order.productName}</h2>
          <p>Please pay: ${order.price}</p>
        </div>
      </div>
      <div className="card flex-shrink-0 w-50 max-w-md shadow-2xl bg-base-100">
        <div className="card-body">
          <Elements stripe={stripePromise}>
            <CheckoutForm order={order} />
          </Elements>
        </div>
      </div>
    </div>
  );
};

export default Payment;
